import React from 'react'
import { useSelector } from 'react-redux'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import {
  EMP_CONTRACT_COMPENSATION_SLIP_PDF,
  EMP_CONTRACT_FULLTIME_PDF,
  EMP_CONTRACT_PDPA_PDF,
  EMP_CONTRACT_SECRET_PDF
} from '../../../router/routes'

export default function NavContract({ active }) {
  // const orgId = useSelector((state) => state.roleReducer.role)
  let [searchParams, setSearchParams] = useSearchParams()
  const code = searchParams.get('code')
  const orgId = searchParams.get('orgId')
  const phones = searchParams.get('phone')
  const phone = phones ? phones.replace(/\s/g, '') : ''
  const idCard = searchParams.get('idCard')
  const contractNo = searchParams.get('contractNo')
  const statusId = searchParams.get('statusId')
  const searchMulti = searchParams.get('searchMulti')

  const navigate = useNavigate()
  const locaiton = useLocation()

  const pathname = locaiton.pathname

  const getLinkQuery = (url) => {
    return `${url}?orgId=${orgId}&phone=${phone}`
  }
  const chkIsSubMenu = (d) => {
    const path = getLinkQuery(
      pathname.split('/')[1] + pathname.split('/')[2] + pathname.split('/')[3]
    )
    const link = d.split('/')[1] + d.split('/')[2] + d.split('/')[3]

    return path === link
  }
  return (
    <>
      <span
        className="m-0 p-0"
        onClick={() => {
          navigate(
            `${EMP_CONTRACT_COMPENSATION_SLIP_PDF}?orgId=${orgId}&code=${code}&phone=${phone}&idCard=${idCard}&statusId=${statusId}&contractNo=${contractNo}&searchMulti=${searchMulti}`
          )
        }}
      >
        <h5
          className={`small text-muted ${
            !chkIsSubMenu(
              `${EMP_CONTRACT_COMPENSATION_SLIP_PDF}?orgId=${orgId}&phone=${phone}`
            ) && 'opacity-25'
          }`}
        >
          ใบแจ้งค่าตอบแทน
        </h5>
      </span>
      <span
        className="text-center m-0 p-0"
        onClick={() => {
          navigate(
            `${EMP_CONTRACT_SECRET_PDF}?orgId=${orgId}&code=${code}&phone=${phone}&idCard=${idCard}&statusId=${statusId}&contractNo=${contractNo}&searchMulti=${searchMulti}`
          )
        }}
      >
        <h5
          className={`small text-muted ${
            !chkIsSubMenu(
              `${EMP_CONTRACT_SECRET_PDF}?orgId=${orgId}&phone=${phone}`
            ) && 'opacity-25'
          }`}
        >
          สัญญารักษาความลับ
        </h5>
      </span>
      <span
        className="m-0 p-0"
        onClick={() => {
          navigate(
            `${EMP_CONTRACT_FULLTIME_PDF}?orgId=${orgId}&code=${code}&phone=${phone}&idCard=${idCard}&statusId=${statusId}&contractNo=${contractNo}&searchMulti=${searchMulti}`
          )
        }}
      >
        <h5
          className={`small text-muted ${
            !chkIsSubMenu(
              `${EMP_CONTRACT_FULLTIME_PDF}?orgId=${orgId}&phone=${phone}`
            ) && 'opacity-25'
          }`}
        >
          สัญญาจ้างงาน
        </h5>
      </span>
      <span
        className=" m-0 p-0"
        onClick={() => {
          navigate(
            `${EMP_CONTRACT_PDPA_PDF}?orgId=${orgId}&code=${code}&phone=${phone}&idCard=${idCard}&statusId=${statusId}&contractNo=${contractNo}&searchMulti=${searchMulti}`
          )
        }}
      >
        <h5
          className={`small text-muted ${
            !chkIsSubMenu(
              `${EMP_CONTRACT_PDPA_PDF}?orgId=${orgId}&phone=${phone}`
            ) && 'opacity-25 '
          }`}
        >
          สัญญา PDPA
        </h5>
      </span>
    </>
  )
}
